var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"current_image"},[_c('a',{attrs:{"aria-label":"View Product Image","target":"_blank","href":_vm.url}},[_c('img',{attrs:{"alt":"Product Image","src":_vm.url}})]),_vm._v(" "),_c('a',{staticClass:"text-danger delete_image",attrs:{"href":"#"},on:{"click":function($event){return _vm.deleteImage($event)}}},[_vm._v("Delete")])])
}
var staticRenderFns = []

export { render, staticRenderFns }